import React from 'react';
const MiniLoader = () => /*#__PURE__*/React.createElement("div", {
  style: {
    textAlign: 'center'
  }
}, /*#__PURE__*/React.createElement("span", {
  className: "miniLoader"
}));
export default MiniLoader;